module.exports = __webpack_public_path__ + "static/map-60d43f0daf815d4e80c9070f407bf2c4.png";